import React, { useEffect, useState } from "react";

import PanelTemplate from "../../templates/Panel";
import BoxTabs from "../../components/BoxTabs";
import InputSelect from "../../components/InputSelect";
import Input from "../../components/Input";
import InputEditor from "../../components/InputEditor";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import api from "../../services/api";
import { createOptions } from "../../helpers/selects";
import InputCheckboxesSublevels from "../../components/InputCheckboxesSublevels";
import { renderError } from "../../helpers/errors";
import { hasPermission } from "../../services/auth";
import ProductVisibility, { visibilityPayload } from "./ProductVisibility";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { convertToSlug } from "../../helpers/masks";
import InputTextarea from "../../components/InputTextarea";

const featuredOptions = [
    { label: 'Sim', value: true },
    { label: 'Não', value: false }
];

const ProductDetailsTab = ({sites, quotable, onVisibilityChange, sku, setSku, featured, setFeatured, recent, setRecent, name, setName, categories, setSelectedCategories, selectedCategories, description, setDescription, techDescription, setTechDescription, tags, tag, setTag, minQuantity, setMinQuantity, ncm, setNcm}) => {
    return (
        <div>
            <div className="row">
                <div className="col-6">
                    <ProductVisibility
                        sites={sites}
                        quotable={quotable}
                        onChange={onVisibilityChange}
                        disabled={!hasPermission('create_product')}
                    />

                    <h2 className="section-title">Informações gerais</h2>
                    <div className="row">                        
                        <div className="col-6">
                            <Input label={`Código SKU`} value={sku} change={setSku} />
                        </div>
                        <div className="col-6">
                            <Input label={`NCM`} value={ncm} change={setNcm} mask={`convertToNCM`} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <InputSelect label={`Destaque`} options={featuredOptions} value={featured} change={setFeatured} />
                        </div>
                        <div className="col-6">
                            <InputSelect label={`Novidade`} options={featuredOptions} value={recent} change={setRecent} />
                        </div>
                    </div>
                    <Input label={`Nome do produto`} value={name} change={setName} />
                    <div className="row">
                        <div className="col-6">
                            <InputSelect label={`Selo`} options={createOptions(tags, 'text', 'id', true)} value={tag} change={setTag} null />
                        </div>
                        <div className="col-6">
                            <Input 
                                label={`Quant. mínima`}
                                value={minQuantity}
                                change={setMinQuantity}
                                mask={`convertToInt`}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-6">
                    <h2 className="section-title">Descrição do produto</h2>
                    <InputEditor value={description} change={setDescription} />

                    <h2 className="section-title">Descrição técnica</h2>
                    <InputEditor value={techDescription} change={setTechDescription} />

                    <h2 className="section-title">Categorias</h2>
                    <InputCheckboxesSublevels
                        options={categories}
                        selecteds={selectedCategories}
                        setSelecteds={setSelectedCategories}
                    />

                </div>
            </div>
        </div>
    );
}

const ImagesTab = () => {
    return (
        <p>Salve o produto para ver esta aba.</p>
    );
}

const VariationsTab = () => {
    return (
        <p>Salve o produto para ver esta aba.</p>
    );
}

const KeyWordsTab = () => {
    return (
        <p>Salve o produto para ver esta aba.</p>
    );
}

const CustomizationsTab = () => {
    return (
        <p>Salve o produto para ver esta aba.</p>
    );
}

const SeoTab = () => {
    return (
        <p>Salve o produto para ver esta aba.</p>
    );
}

export const ProductCreate = () => {
    const navigete = useNavigate();
    const location = useLocation();

    // Vindo de "Adicionar produto > Cadastro próprio" na marca: a marca já vem
    // ligada (e o site principal desligado, padrão do cadastro) e o fluxo volta
    // para a aba Produtos dela.
    const brandId = new URLSearchParams(location.search).get('brand');
    const backToBrand = brandId ? `/brand/edit/${brandId}?tab=products` : null;

    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);

    const [sites, setSites] = useState(null);
    const [quotable, setQuotable] = useState(true);

    const [tags, setTags] = useState([]);
    
    const [sku, setSku] = useState('');
    const [ncm, setNcm] = useState('');
    const [featured, setFeatured] = useState(false);
    const [recent, setRecent] = useState(false);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [techDescription, setTechDescription] = useState('');
    const [tag, setTag] = useState(null);
    const [minQuantity, setMinQuantity] = useState(1);


    useEffect(() => {
        getCategories();
        getSites();
        getTags();
    }, []);

    const getTags = () => {
        api.get(`/tag`).then(res => {
            setTags(res.data.resources);
        });
    }

    const getCategories = () => {
        api.get(`/category`).then(res => {
            let toCategories = [];

            res.data.resources.map(category => {
                let options = [];

                category.categories.map(subcategory => {
                    options.push({
                        label: subcategory.name,
                        value: subcategory.id
                    })
                });
                toCategories.push({
                    label: category.name,
                    value: category.id,
                    options
                })
            })
            setCategories(toCategories);
        });
    }

    const getSites = () => {
        api.get(`/product/sites/new`).then(res => {
            const resource = res.data.resource;
            setSites(brandId
                ? { ...resource, brands: resource.brands.map(brand => brand.id === brandId ? { ...brand, on_site: true } : brand) }
                : resource);
        }).catch(error => renderError(error));
    }

    const brandName = brandId ? sites?.brands.find(brand => brand.id === brandId)?.name : null;

    const storeProduct = () => {
        setLoading(true);

        api.post(`/product`, {
            quotable,
            visibility: visibilityPayload(sites),
            recent,
            featured,
            name,
            sku,
            ncm,
            description,
            tech_description: techDescription,
            meta_title: name,
            meta_description: name,
            categories: selectedCategories,
            keywords: [],
            customizations: [],
            subproducts: [],
            slug: name,
            tag_id: tag,
            min_quantity: minQuantity
        }).then(res => {
            toast.success('Produto cadastrado com sucesso');
            navigete(`/product/edit/${res.data.resource.id}${backToBrand ? `?return_to=${encodeURIComponent(backToBrand)}` : ''}`);
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    return (
        <>
            <PanelTemplate id="product-edit">
                {brandName &&
                    <div className="product-brand-context">
                        <span>Cadastrando para a <strong>{brandName}</strong>. As fotos e as variações entram depois de salvar.</span>
                        <Link to={backToBrand}>Voltar para a marca</Link>
                    </div>
                }
                <BoxTabs
                    titles={[
                        'Detalhes dos produtos',
                        'Imagens',
                        'Cores, estoque e preço',
                        'Palavras-chave', 
                        'Gravações', 
                        'SEO'
                    ]}
                    contents={[
                        <ProductDetailsTab
                            sites={sites}
                            quotable={quotable}
                            onVisibilityChange={({ sites: nextSites, quotable: nextQuotable }) => {
                                setSites(nextSites);
                                setQuotable(nextQuotable);
                            }}
                            sku={sku}
                            setSku={setSku}
                            featured={featured}
                            setFeatured={setFeatured}
                            recent={recent}
                            setRecent={setRecent}
                            name={name}
                            setName={setName}
                            categories={categories}
                            setSelectedCategories={setSelectedCategories}
                            selectedCategories={selectedCategories}
                            setDescription={setDescription}
                            description={description}
                            setTechDescription={setTechDescription}
                            techDescription={techDescription}
                            tags={tags}
                            tag={tag}
                            setTag={setTag}
                            minQuantity={minQuantity}
                            setMinQuantity={setMinQuantity}
                            ncm={ncm}
                            setNcm={setNcm}
                        />,
                        <ImagesTab />,
                        <VariationsTab />,
                        <KeyWordsTab />,
                        <CustomizationsTab />,
                        <SeoTab />,
                    ]}
                />
                <PageFooter>
                    <Button 
                        type={`primary`}
                        size={`small`}
                        svg={`save-white`}
                        text={`Salvar alterações`}
                        action={storeProduct}
                        loading={loading}
                    />
                </PageFooter>
            </PanelTemplate>
        </>
    );
}

export default ProductCreate;